// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-1e51e6c3] {\n  position: absolute;\n  right: 10px;\n  top: 20px;\n}", ""]);
// Exports
module.exports = exports;
